/* 谷仓 数据字典 */

// 客户类型
export const customerTypeEnum = [
  // 谷仓
  { value: 1, label: '个人' },
  { value: 2, label: '公司' },
  // 云途
  {
    value: 3,
    label: '大陆个人'
  },
  {
    value: 4,
    label: '大陆公司'
  },
  {
    value: 5,
    label: '香港公司'
  },
  {
    value: 6,
    label: '海外公司'
  }
]

// 所属组织
export const orgEnum = [
  { value: 'cos_fbu', label: '谷仓-销售管理' },
  { value: 'cos_lbu', label: '云途-销售管理' },
  { value: 'cos_ofbu', label: '谷仓-海外销售' }
]
// 业务系统
export const sysEnum = [
  { value: 'CRM', label: 'CRM' },
  { value: 'GD', label: 'GD' },
  { value: 'ELD', label: 'ELD' },
  { value: 'TOMS', label: 'TOMS' }
]
// 所属品牌
export const brandEnum = [
  { value: 'YT', label: 'YT' },
  { value: 'WT', label: 'WT' },
  { value: '谷仓', label: '谷仓' },
  { value: 'Elogistis', label: 'Elogistis' },
  { value: '易可达', label: '易可达' }
]
export const freezeStatus = [
  { value: 1, label: '正常' },
  { value: 2, label: '冻结' }
]
export const mergeFlag = [
  { value: 1, label: '已合并' },
  { value: 2, label: '未合并' }
]
export const customerStatus = [
  { label: '线索公海池', value: 0 },
  { label: '待领取', value: 1 },
  { label: '待跟进', value: 2 },
  { label: '跟进中', value: 3 },
  { label: '无效线索', value: 5 },
  { label: '已转换', value: 8 },
  { label: '谈判', value: 10 },
  { label: '已注册', value: 11 },
  { label: '搁置', value: 12 },
  { label: '无合作可能', value: 13 },
  { label: '归档', value: 14 },
  { label: '对接中', value: 20 },
  { label: '暂停合作', value: 21 },
  { label: '终止合作', value: 22 },
  { label: '已签约', value: 30 },
  { label: '磨合', value: 31 },
  { label: '上涨', value: 32 },
  { label: '下降', value: 33 },
  { label: '稳定', value: 34 },
  { label: '保持', value: 35 },
  { label: '流失', value: 36 },
  { label: '首次发件', value: 37 },
  { label: '本年度新客户', value: 38 },
  { label: '激活客户', value: 39 }
]
export default {
  customerTypeEnum,
  orgEnum,
  sysEnum,
  brandEnum,
  freezeStatus,
  mergeFlag,
  customerStatus
}
